import { useParams } from "react-router-dom";

import { Layout } from "Layout";

import { ListPage } from "components/ListPage/ListPage";

import { i18n } from "services/i18nService";

import { useEditModal } from "hooks/useEditModal";
import { usePlans } from "hooks/usePlans";
import { usePrivileges } from "hooks/usePrivileges";

import { Forbidden } from "Forbidden";
import { OBJECT_TYPES, USER_PRIVILEGE } from "appConstants";

const objectType = OBJECT_TYPES.PROCESS.fullString;

export function ProcessList() {
  const { id } = useParams();

  const { hasPrivilegesOrIsAdmin } = usePrivileges();
  const { hasAtLeastProPlan } = usePlans();

  const hasPrivileges = hasPrivilegesOrIsAdmin(USER_PRIVILEGE.buildAssemblies);

  useEditModal(objectType, id);

  const allowList = hasPrivileges && hasAtLeastProPlan;
  useEditModal(objectType, id, allowList);

  return (
    <Layout pageTitle={i18n(`objectType.${objectType}.SentencePlural`)}>
      {allowList ? <ListPage objectType={objectType} /> : <Forbidden />}
    </Layout>
  );
}
